import { createContext, useContext } from 'react';
import type { Session } from './useSession';

export const SessionContext = createContext<Session | null>(null);

export function useSessionContext(): Session {
  const s = useContext(SessionContext);
  if (!s) throw new Error('SessionContext missing');
  return s;
}
